<div class="toolbar fixed-top" style="z-index: 900" role="banner">
  <a [routerLink]="['/secured/home']" style="height: initial" class="udt-logo">
    <img width="120" alt="UDT HUB Logo" src="../../../../assets/images/UDTHub_All_White.png" />
  </a>

  <div class="headerMessage">
    <div class="d-flex flex-row align-items-center">
      <div class="d-flex flex-column mr-2">
        <p class="mb-0 text-white">Hi {{ profile.givenName | titlecase }}</p>
        @if (isBusinessUnitEnabled && locationContext) {
          <p class="mb-0 text-white" style="font-size: 0.85rem; opacity: 0.8">{{ locationContext }}</p>
        }
      </div>
      @if (canSwitchAccounts) {
        <div class="filter-container">
          <mat-form-field
            class="companies-pill-select active"
            style="display: inline-block"
            data-testid="switch-accounts-select"
          >
            <mat-label>Company</mat-label>
            <mat-select
              [panelWidth]="312"
              [panelClass]="'companies-pill-select__menu'"
              [(value)]="selectedAccountId"
              (selectionChange)="onSelectedAccountChange($event)"
              (openedChange)="onSelectOpenedChange($event)"
            >
              <div class="search-container d-flex justify-content-center">
                <mat-form-field class="accounts-input">
                  <mat-label class="search-label">Search</mat-label>
                  <input
                    matInput
                    [(ngModel)]="searchAccount"
                    (keydown.space)="$event.stopPropagation()"
                    (input)="onSearchChange()"
                  />
                  <mat-icon>search</mat-icon>
                </mat-form-field>
              </div>
              @for (account of crossAccounts; track account.id) {
                <mat-option class="menu-option" [value]="account.id">
                  {{ account.description }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }
    </div>
  </div>
  <div class="flex-grow-1 d-flex">
    @if (showGlobalSearch) {
      <app-global-search [ngStyle]="{ width: '100%', display: 'flex', 'justify-content': 'center' }">
      </app-global-search>
    }
  </div>
  <div class="d-flex justify-content-center align-items-center">
    <button
      class="help__button d-flex justify-content-center align-items-center mr-2 mt-1"
      (click)="openNotifications()"
    >
      <mat-icon
        [matBadge]="totalUnreadNotifications() > 9 ? '9+' : totalUnreadNotifications()"
        matBadgeColor="warn"
        [matBadgeHidden]="totalUnreadNotifications() === 0"
      >
        notifications_none
      </mat-icon>
    </button>
    <button
      class="help__button d-flex justify-content-center align-items-center mr-2 mt-1"
      matTooltip="Help Center"
      matTooltipClass="help__tooltip"
      (click)="openHelpCenter()"
    >
      <span aria-label="Help Center Logo">?</span>
    </button>
    <button
      mat-button
      aria-label="User menu"
      [matMenuTriggerFor]="menu"
      class="headerButton d-inline-block"
      data-testid="account-icon-button"
    >
      <div class="d-flex align-items-center" style="line-height: 65px; padding-top: 2px">
        <span class="accountIcon text-white" style="line-height: initial">
          {{ profile.givenName.charAt(0) | titlecase }}{{ profile.familyName.charAt(0) | titlecase }}
        </span>
        &nbsp; &nbsp;
        <mat-icon class="d-none d-md-inline-block text-white">keyboard_arrow_down</mat-icon>
      </div>
    </button>
  </div>
  <mat-menu #menu="matMenu" class="udt-hub-menu">
    <button mat-menu-item routerLink="/secured/profile" type="button">
      <!-- <mat-icon>account_circle</mat-icon> -->
      <mat-icon>person_outline</mat-icon>
      <span>Profile</span>&nbsp;&nbsp;
    </button>

    @if (isGlobalSettingsEnabled) {
      <button mat-menu-item routerLink="/secured/global-settings" type="button">
        <img
          src="../../../../../assets/images/icons/icon_global-settings-2.svg"
          alt="Global settings icon"
          class="dark-mode-icon"
          width="24"
          height="24"
          [style]="{ 'margin-right': '16px' }"
        />
        <span>Global Settings</span>&nbsp;&nbsp;
      </button>
    }

    @if (isSuperAdmin && hubEnvironment == 'dev') {
      <button mat-menu-item routerLink="/secured/super-admin-center" type="button">
        <img
          src="../../../../../assets/images/icons/icon-super-admin-center.svg"
          alt="Global settings icon"
          class="dark-mode-icon"
          width="24"
          height="24"
          [style]="{ 'margin-right': '16px' }"
        />
        <span>Super Admin</span>&nbsp;&nbsp;
      </button>
    }

    <button mat-menu-item type="button" (click)="passwordReset()" [disabled]="!allowPasswordReset">
      <mat-icon>lock_open</mat-icon>
      <span>Reset Password</span>&nbsp;&nbsp;
    </button>

    @if (tenantOptions) {
      <div>
        <button class="profile-menu-section" mat-menu-item disabled>
          <span>Tenant</span>
        </button>
        <button
          mat-menu-item
          routerLink="/secured/user-permissions"
          type="button"
          class="tenant"
          data-testid="user-permissions"
        >
          <!-- <mat-icon>group</mat-icon> -->
          <mat-icon>people_outline</mat-icon>
          <span>Users & Permissions</span>&nbsp;&nbsp;
        </button>
        <!-- <button mat-menu-item type="button" class="tenant">
        &nbsp;&nbsp;&nbsp;
        <mat-icon>receipt</mat-icon>
        <span>Invoice</span>&nbsp;&nbsp;
      </button> -->
      </div>
    }

    @if (isSuperAdmin) {
      <button (click)="openHubMetrics()" mat-menu-item type="button">
        <mat-icon>data_usage</mat-icon>
        <span>Hub Metrics</span>&nbsp;&nbsp;
      </button>
    }

    <button [matMenuTriggerFor]="theme" mat-menu-item type="button" class="mat-menu-item-theme">
      <img
        src="../../../../../assets/images/icons/icon_settings-night-sight.svg"
        alt="Icon settings night sight"
        class="dark-mode-icon"
        width="24"
        height="24"
        [style]="{ 'margin-right': '16px' }"
      />
      <span>Theme</span>&nbsp;&nbsp;
    </button>

    <button mat-menu-item type="button" (click)="logOut()" data-testid="logout-button">
      <mat-icon>logout</mat-icon>
      <span>Logout</span>&nbsp;&nbsp;
    </button>
  </mat-menu>

  <mat-menu #theme="matMenu" class="udt-hub-menu mat-menu-theme">
    <button mat-menu-item (click)="onThemeChanged('light')" [ngClass]="{ active: currentTheme === 'light' }">
      <span class="d-flex">
        <img
          src="../../../../../assets/images/icons/icon_light-mode.svg"
          alt="Icon light mode"
          class="dark-mode-icon"
          width="24"
          height="24"
          [style]="{ 'margin-right': '16px' }"
        />Light
        @if (currentTheme === 'light') {
          <mat-icon color="primary" [style]="{ 'margin-left': '75px' }">check</mat-icon>
        }
      </span>
    </button>
    <button mat-menu-item (click)="onThemeChanged('dark')" [ngClass]="{ active: currentTheme === 'dark' }">
      <span class="d-flex">
        <img
          src="../../../../../assets/images/icons/icon_dark-mode.svg"
          alt="Icon dark mode"
          class="dark-mode-icon"
          width="24"
          height="24"
          [style]="{ 'margin-right': '16px' }"
        />Dark
        @if (currentTheme === 'dark') {
          <mat-icon color="primary" [style]="{ 'margin-left': '75px' }">check</mat-icon>
        }
      </span>
    </button>
    <button mat-menu-item (click)="onThemeChanged('auto')" [ngClass]="{ active: currentTheme === 'auto' }">
      <span class="d-flex">
        <img
          src="../../../../../assets/images/icons/icon_brightness.svg"
          alt="Icon auto mode"
          class="dark-mode-icon"
          width="24"
          height="24"
          [style]="{ 'margin-right': '16px' }"
        />Auto
        @if (currentTheme === 'auto') {
          <mat-icon color="primary" [style]="{ 'margin-left': '75px' }">check</mat-icon>
        }
      </span>
    </button>
  </mat-menu>
</div>
@if (isHelpCenterOpen) {
  <help-center (closeEvent)="closeHelpCenter($event)"></help-center>
}
@if (areNotificationsOpen) {
  <notifications
    [(notifications)]="notifications"
    (closeEvent)="closeNotifications($event)"
    [unreadNotificationsCount]="totalUnreadNotifications()"
  >
  </notifications>
}
